import { useCallback, useEffect, useRef, useState } from 'react';

interface IParams {
  padding?: number;
}

export function useResponsiveSliderSize({ padding = 0 }: IParams = {}) {
  const sliderRef = useRef<HTMLDivElement>(null);
  const dotsRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  const updateSize = useCallback(() => {
    const sliderEl = sliderRef.current;

    if (!sliderEl) {
      return;
    }

    const width = sliderEl.offsetWidth - padding * 2;
    const height = sliderEl.offsetHeight - (dotsRef.current?.offsetHeight || 0);

    setSize({ width, height });
  }, [padding]);

  useEffect(() => {
    updateSize();

    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, [updateSize]);

  return { sliderRef, dotsRef, size };
}
